module.exports = __webpack_public_path__ + "static/img/icon.f2bbe689.png";